import React from "react";

function ColorCircle( props: {
	color: string
} ) {
	return <div className={"color-circle"} style={{
		backgroundColor: props.color,
	}} />;
}

export default ColorCircle;
